import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3e82db64 = () => interopDefault(import('../pages/apps/index.vue' /* webpackChunkName: "pages/apps/index" */))
const _df17e7e0 = () => interopDefault(import('../pages/biller/index.vue' /* webpackChunkName: "pages/biller/index" */))
const _43c3ce2e = () => interopDefault(import('../pages/chatbot/index.vue' /* webpackChunkName: "pages/chatbot/index" */))
const _2201a4be = () => interopDefault(import('../pages/coming-soon.vue' /* webpackChunkName: "pages/coming-soon" */))
const _ef899560 = () => interopDefault(import('../pages/communication/index.vue' /* webpackChunkName: "pages/communication/index" */))
const _0dec1908 = () => interopDefault(import('../pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _87233d7c = () => interopDefault(import('../pages/invoices/index.vue' /* webpackChunkName: "pages/invoices/index" */))
const _bb8678d6 = () => interopDefault(import('../pages/login-signup.vue' /* webpackChunkName: "pages/login-signup" */))
const _51e8d8fb = () => interopDefault(import('../pages/menu/index.vue' /* webpackChunkName: "pages/menu/index" */))
const _7b7f7470 = () => interopDefault(import('../pages/order/index.vue' /* webpackChunkName: "pages/order/index" */))
const _e40798da = () => interopDefault(import('../pages/reciever/index.vue' /* webpackChunkName: "pages/reciever/index" */))
const _22f34650 = () => interopDefault(import('../pages/report/index.vue' /* webpackChunkName: "pages/report/index" */))
const _12626771 = () => interopDefault(import('../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _3646580e = () => interopDefault(import('../pages/menu/bulk-edit.vue' /* webpackChunkName: "pages/menu/bulk-edit" */))
const _bf235776 = () => interopDefault(import('../pages/menu/modification-request.vue' /* webpackChunkName: "pages/menu/modification-request" */))
const _9a6618b0 = () => interopDefault(import('../pages/menu/upload.vue' /* webpackChunkName: "pages/menu/upload" */))
const _2142d2cc = () => interopDefault(import('../pages/order/cart.vue' /* webpackChunkName: "pages/order/cart" */))
const _845be902 = () => interopDefault(import('../pages/order/feedback.vue' /* webpackChunkName: "pages/order/feedback" */))
const _40b6591c = () => interopDefault(import('../pages/order/menu/index.vue' /* webpackChunkName: "pages/order/menu/index" */))
const _56fe4384 = () => interopDefault(import('../pages/report/items.vue' /* webpackChunkName: "pages/report/items" */))
const _3fae73d7 = () => interopDefault(import('../pages/report/orders.vue' /* webpackChunkName: "pages/report/orders" */))
const _2a8037f5 = () => interopDefault(import('../pages/restaurant/create-restaurant.vue' /* webpackChunkName: "pages/restaurant/create-restaurant" */))
const _1da05b6c = () => interopDefault(import('../pages/restaurant/device-preferences.vue' /* webpackChunkName: "pages/restaurant/device-preferences" */))
const _2a282837 = () => interopDefault(import('../pages/settings/app-configuration.vue' /* webpackChunkName: "pages/settings/app-configuration" */))
const _6b30a3b0 = () => interopDefault(import('../pages/settings/billing.vue' /* webpackChunkName: "pages/settings/billing" */))
const _24206f90 = () => interopDefault(import('../pages/settings/channel-manager.vue' /* webpackChunkName: "pages/settings/channel-manager" */))
const _99ecf9ea = () => interopDefault(import('../pages/settings/general-settings.vue' /* webpackChunkName: "pages/settings/general-settings" */))
const _92f0f6c0 = () => interopDefault(import('../pages/settings/restaurant.vue' /* webpackChunkName: "pages/settings/restaurant" */))
const _7a8f7497 = () => interopDefault(import('../pages/settings/settings-options.vue' /* webpackChunkName: "pages/settings/settings-options" */))
const _19e7c26e = () => interopDefault(import('../pages/settings/user.vue' /* webpackChunkName: "pages/settings/user" */))
const _1db5aa5c = () => interopDefault(import('../pages/settings/user-settings.vue' /* webpackChunkName: "pages/settings/user-settings" */))
const _2bb1d2ee = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _58690115 = () => interopDefault(import('../pages/order/address/_id.vue' /* webpackChunkName: "pages/order/address/_id" */))
const _673aba3d = () => interopDefault(import('../pages/order/status/_orderId.vue' /* webpackChunkName: "pages/order/status/_orderId" */))
const _7fc8d036 = () => interopDefault(import('../pages/apps/_id.vue' /* webpackChunkName: "pages/apps/_id" */))
const _938243ba = () => interopDefault(import('../pages/menu/_id.vue' /* webpackChunkName: "pages/menu/_id" */))
const _4b284922 = () => interopDefault(import('../pages/menu/_id/combo.vue' /* webpackChunkName: "pages/menu/_id/combo" */))
const _a1c9bea2 = () => interopDefault(import('../pages/menu/_id/item.vue' /* webpackChunkName: "pages/menu/_id/item" */))
const _0b900af4 = () => interopDefault(import('../pages/order/_token.vue' /* webpackChunkName: "pages/order/_token" */))
const _d0e81d44 = () => interopDefault(import('../pages/reciever/_order.vue' /* webpackChunkName: "pages/reciever/_order" */))
const _5f645776 = () => interopDefault(import('../pages/_location/_brand/menu/index.vue' /* webpackChunkName: "pages/_location/_brand/menu/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/apps",
    component: _3e82db64,
    name: "apps"
  }, {
    path: "/biller",
    component: _df17e7e0,
    name: "biller"
  }, {
    path: "/chatbot",
    component: _43c3ce2e,
    name: "chatbot"
  }, {
    path: "/coming-soon",
    component: _2201a4be,
    name: "coming-soon"
  }, {
    path: "/communication",
    component: _ef899560,
    name: "communication"
  }, {
    path: "/forgot-password",
    component: _0dec1908,
    name: "forgot-password"
  }, {
    path: "/invoices",
    component: _87233d7c,
    name: "invoices"
  }, {
    path: "/login-signup",
    component: _bb8678d6,
    name: "login-signup"
  }, {
    path: "/menu",
    component: _51e8d8fb,
    name: "menu"
  }, {
    path: "/order",
    component: _7b7f7470,
    name: "order"
  }, {
    path: "/reciever",
    component: _e40798da,
    name: "reciever"
  }, {
    path: "/report",
    component: _22f34650,
    name: "report"
  }, {
    path: "/signup",
    component: _12626771,
    name: "signup"
  }, {
    path: "/menu/bulk-edit",
    component: _3646580e,
    name: "menu-bulk-edit"
  }, {
    path: "/menu/modification-request",
    component: _bf235776,
    name: "menu-modification-request"
  }, {
    path: "/menu/upload",
    component: _9a6618b0,
    name: "menu-upload"
  }, {
    path: "/order/cart",
    component: _2142d2cc,
    name: "order-cart"
  }, {
    path: "/order/feedback",
    component: _845be902,
    name: "order-feedback"
  }, {
    path: "/order/menu",
    component: _40b6591c,
    name: "order-menu"
  }, {
    path: "/report/items",
    component: _56fe4384,
    name: "report-items"
  }, {
    path: "/report/orders",
    component: _3fae73d7,
    name: "report-orders"
  }, {
    path: "/restaurant/create-restaurant",
    component: _2a8037f5,
    name: "restaurant-create-restaurant"
  }, {
    path: "/restaurant/device-preferences",
    component: _1da05b6c,
    name: "restaurant-device-preferences"
  }, {
    path: "/settings/app-configuration",
    component: _2a282837,
    name: "settings-app-configuration"
  }, {
    path: "/settings/billing",
    component: _6b30a3b0,
    name: "settings-billing"
  }, {
    path: "/settings/channel-manager",
    component: _24206f90,
    name: "settings-channel-manager"
  }, {
    path: "/settings/general-settings",
    component: _99ecf9ea,
    name: "settings-general-settings"
  }, {
    path: "/settings/restaurant",
    component: _92f0f6c0,
    name: "settings-restaurant"
  }, {
    path: "/settings/settings-options",
    component: _7a8f7497,
    name: "settings-settings-options"
  }, {
    path: "/settings/user",
    component: _19e7c26e,
    name: "settings-user"
  }, {
    path: "/settings/user-settings",
    component: _1db5aa5c,
    name: "settings-user-settings"
  }, {
    path: "/",
    component: _2bb1d2ee,
    name: "index"
  }, {
    path: "/order/address/:id?",
    component: _58690115,
    name: "order-address-id"
  }, {
    path: "/order/status/:orderId?",
    component: _673aba3d,
    name: "order-status-orderId"
  }, {
    path: "/apps/:id",
    component: _7fc8d036,
    name: "apps-id"
  }, {
    path: "/menu/:id",
    component: _938243ba,
    name: "menu-id",
    children: [{
      path: "combo",
      component: _4b284922,
      name: "menu-id-combo"
    }, {
      path: "item",
      component: _a1c9bea2,
      name: "menu-id-item"
    }]
  }, {
    path: "/order/:token",
    component: _0b900af4,
    name: "order-token"
  }, {
    path: "/reciever/:order",
    component: _d0e81d44,
    name: "reciever-order"
  }, {
    path: "/:location/:brand?/menu",
    component: _5f645776,
    name: "location-brand-menu"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
